module.exports = __webpack_public_path__ + "static/media/categories_step_1_2.d0de9dd8.svg";